import React from "react";
import aboutImg1 from "../images/Prernabg.png";
import aboutImg2 from "../images/MyApproach.png";

const About = () => {
  return (
    <>
      <section id="about" className="animate">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-4">
              <img
                src={aboutImg1}
                alt="About Anchor Point"
                className="about-img"
              />
            </div>
            <div className="col-lg-8">
              <div className="about_text">
                <h2 className="mb-2">LEARN ABOUT YOUR COACH – PRERNA </h2>
                <h4>Rooted in Experience. Driven by Transformation.</h4>
                <p>
                  With 13+ years across Banking, NBFC, Market Research and
                  Education, I’ve experienced the realities of high-pressure
                  corporate life—tight deadlines, constant change and the
                  challenge of staying grounded while striving for growth.
                </p>
                <p>
                  My journey into life coaching and mental health began with a
                  simple intention:
                  <strong>to become the support I once needed</strong> .
                </p>
                <p>
                  Today, I combine corporate insight with professional training
                  to help individuals build lives that are not just
                  successful—but sustainable, balanced and fulfilling.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="animate">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-8 order-lg-1 order-2">
              <div className="our_approach">
                <h4 className="mb-2">Credentials</h4>
                <ul>
                  <li>
                    Professional Diploma in Counselling & Guidance (Grade A+)
                  </li>
                  <li> Certified Mental Health Professional (MHI5815)</li>
                  <li> Member, International Psychological Association</li>
                  <li> Psychotherapy Training (UNDP/ECOSOC associated)</li>
                </ul>
                <h4 className="mb-2 mt-5">Beyond Work</h4>
                <p>
                  I’m also a mother, learning and living the reality of balance
                  every day. Because true success isn’t just career growth—it’s
                  having the clarity, time and peace to be present for what
                  truly matters.
                </p>
                <h4 className="mb-2 mt-5">My Approach</h4>
                <ul>
                  <li> Empathetic and non-judgmental</li>
                  <li>Structured yet flexible</li>
                  <li>Focused on self-awareness and action</li>
                </ul>
                <h4 className="mb-2 mt-5">I Help You:</h4>
                <ul>
                  <li>Gain clarity and direction</li>
                  <li>Overcome self-doubt and emotional blocks</li>
                  <li>Navigate life and career transitions</li>
                  <li>Build confidence and purpose-driven lives</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 order-lg-2 order-1">
              <img
                style={{ position: "sticky", top: "100px" }}
                src={aboutImg2}
                alt="Our Coaching Approach"
                className="approach-img"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
